import { render, staticRenderFns } from "./BoardSectionIndex.vue?vue&type=template&id=674881ae&scoped=true&"
import script from "./BoardSectionIndex.vue?vue&type=script&lang=ts&"
export * from "./BoardSectionIndex.vue?vue&type=script&lang=ts&"
import style0 from "./BoardSectionIndex.vue?vue&type=style&index=0&id=674881ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674881ae",
  null
  
)

export default component.exports